import {Tooltip} from "@material-ui/core";
import {roundToFixed} from "../../../services/util/helperFuncs";
import React from "react";

export const DurationCell = ({ template, t }) => {
  
  return (
    <Tooltip title={
      <div>
        <strong>{t('driveTime')}:</strong> {roundToFixed(template.travelDurationInMin, 0)}
        <br/>
        <strong>{t('dwellTime')}:</strong> {roundToFixed(template.dwellTimeDurationInMin, 0)}
      </div>
    }>
      <div>
        {roundToFixed(template.travelDurationInMin + template.dwellTimeDurationInMin)}
      </div>
    </Tooltip>
  );
};